import { ItemViewModel } from '@/definitions/view-models';
import { Counter } from '@/api';
import { MultisidebarItem } from '@/store/multisidebar/types';

export default async function ({ model }: MultisidebarItem<ItemViewModel<Counter>>) {
  return { label: model.item?.name || '' };
}
